import { market } from "../market/fr";
import { invite } from '../invite/fr';
import { property } from '../property/fr';
import {advertise} from '../advertise/fr';
import {login, download} from '../login/fr';
import {trading} from '../trading1/fr';
import { contest } from "../contest/fr";
import { merchandiser, common, tableList, dialog, codeInfo, hyy as contractHyy, placeOrder, codelist, panKou } from "../merchandiser/fr";
import { games } from '../games/fr';
import { taskCenter } from "../task/fr";
import { ieo } from "../ieo/fr";
import { earn } from "../earn/fr";
import { tradingContest } from "../tradingContest/fr";
import { agent } from "../agent/fr";
import { live } from "../live/fr";
import { hongbao } from "../hongbao/fr";

const time = {
  r: "j",
  s: "h",
  f: "m",
  m: "s",
};
// Statuts
const state = {
  preheatIng: "Préchauffage",
  purchaseIng: "Achat en cours",
  over: "Terminé",
  finish: "Terminé",
  noData: "Aucune donnée",
  process: "En cours",
  sellout: "Épuisé",
};
// Texte des modèles
const text = {
  now: "En cours",
  start: "Début dans",
  end: "Fin dans",
  jd: "Progression",
  complete: "Terminé",
  limited: "Prix à durée limitée",

  finish: "Terminé",
  subscribing: "Souscription",
  subscribeNow: "Souscrire",
  buyStart: "Début de la souscription dans",
  buyEnd: "Fin de la souscription dans",
  projectAmount: "Nombre de parts",
  quota: "Quota par part",
  buyPrice: "Prix de souscription",
  buyLimit: "Limite de souscription",
  buyAmount: "Quantité de souscription",
  buyPos: "Position de la devise de souscription",
  startDate: "Date de début",
  endDate: "Date de fin",
  projectSuppot: "Support du projet",
  websit: "Site web du projet",
  projectDetail: "Détails du projet",
  cycle: "Cycle de souscription",
  all: "Tous",
  step1: "Préchauffage",
  step2: "Souscription",
  step3: "Tirage au sort",
  step4: "Annonce des résultats",
  subOrder: "Ordres de souscription",
  myOrder: "Ordres gagnants",
  proCoin: "Devise du projet",
  buyCoin: "Devise de souscription",
  orderDate: "Date de l'ordre",
  issuanceQuota: "Quota émis",
  dealAmount: "Quantité exécutée",
  dealPrice: "Montant exécuté",
  status: "Statut",
  ctrl: "Action",
  checkOrder: "Voir les numéros de tirage",
  subNum: "Numéro de tirage",
  myNum: "Numéro gagnant",
  status0: "Souscrit",
  status1: "En attente de débit",
  status2: "Terminé",
  conditionTerm1: "* jours avant le début de la souscription,",
  conditionTerm2: "Paire de trading *",
  conditionTerm3: "Toutes les paires de trading",
  conditionTerm4: "Pour chaque * du montant total des transactions sur le marché spot, vous pouvez souscrire 1 part.",
  noData: "Aucune donnée",
  qgsc: "Verrouillage d'achat",
  yhsg: "Tirage au sort",
  sgsb: "Échec de la souscription",

  supply: "Quota de cette série",
  rate: "Taux de change",
  ceiling: "Limite d'aide",
  xmwc: "Projet terminé",
  xmze: "Montant total du projet",
  zkjj: "Prix moyen réduit",
  cyrs: "Nombre de participants",
  round: "Série n°[*]",
  r: "pers",
  cgqg: "Achat réussi",
  cgzl: "Aide réussie",
  xmed: "Quota du projet",
  kszl: "Début de l'aide",
  ksqg: "Début de l'achat",
  jsqg: "Fin de l'achat",
  jszl: "Fin de l'aide",
  hdgz: "Règles de l'activité",
  xmjs: "Présentation du projet",
  tcqr: "Si vous quittez après avoir confirmé le paiement, vous risquez de perdre cette opportunité d'achat. Veuillez agir avec prudence !",
  jxtc: "Continuer à quitter",
  fhzf: "Retour au paiement",
  qgrsd: "Beaucoup de personnes tentent d'acheter en ce moment, veuillez patienter !",
  zltcqr: "Si vous quittez après avoir confirmé le paiement, vous risquez de perdre cette opportunité d'aide. Veuillez agir avec prudence !",
  zlqgrsd: "Beaucoup de personnes aident en ce moment, veuillez patienter !",
  wxts: "Note : Veuillez confirmer le paiement dès que possible. Si le paiement n'est pas effectué dans les [*] minutes, la session expirera et la fenêtre se fermera.",
};

const seckill = {
  sgno: "Vous ne remplissez pas les conditions de souscription",
  srjymm: "Veuillez entrer votre mot de passe de trading",
  ljzf: "Payer",
};
const apply = {
  condition: "Conditions de souscription",
  apply: "Souscrire",
  buyPrice: "Prix de souscription",
  buyAmount: "Quantité de souscription",
  applyAmount: "Montant de la souscription",
  forget: "Mot de passe de trading oublié ?",
  noAmount: "Veuillez entrer la quantité de souscription",
  buyLimit: "Limite de souscription",
  success: "Souscription réussie !",
  paySummary:"Note : Veuillez confirmer le paiement dès que possible. Si le paiement n'est pas effectué dans les <b>3 minutes</b>, la session expirera et la fenêtre se fermera.",
  appFull: "Quantité de souscription trop élevée",
  seckill_async_fail_13: "Le délai entre deux souscriptions est de {} minutes.",
};

const seckillRes = {
  seckill_async_3: "Paiement en cours, veuillez patienter !",
  seckill_async_5: "Annulation réussie",
  seckill_async_fail_1: "Désolé ! Veuillez rafraîchir la page et réessayer !",
  seckill_async_fail_2: "Désolé ! Veuillez rafraîchir la page et réessayer !",
  seckill_async_fail_3: "Désolé ! Veuillez rafraîchir la page et réessayer !",
  seckill_async_fail_4: "Désolé ! Le quota est épuisé !",
  seckill_async_fail_5: "Désolé ! Le paiement a expiré, veuillez réessayer !",
  seckill_async_fail_6: "Mot de passe de paiement incorrect, veuillez le ressaisir !",
  seckill_async_fail_7: "Trop de tentatives de mot de passe de trading, veuillez réessayer plus tard !",
  seckill_async_fail_8: "Désolé ! Le paiement a expiré, veuillez réessayer !",
  seckill_async_fail_9: "Désolé ! Le quota est épuisé, nous espérons que vous réussirez la prochaine fois !",
  seckill_async_fail_10: "Beaucoup de personnes tentent d'acheter, veuillez réessayer plus tard !",
  seckill_async_fail_11: "Échec de la vérification comportementale !",
};
const header = {
  zcgl: "Gestion des actifs",
  zczh: "Compte d'actifs",
  bbzh: "Compte Spot",
  fbzh: "Compte d'achat",
  bdbzh: "Compte de prêt",
  wdgl: "Gestion des ordres",
  lswt: "Ordres historiques",
  qbhz: "Transfert entre portefeuilles",
  yhzx: "Centre utilisateur",
  wdhb: "Mes enveloppes rouges",
  openOrder: "Ordres actuels",
  dealStats: "Statistiques d'exécution",
  totalAsset: "Valorisation totale des actifs",
  cz: "Compte Futures",
  gmcnyt: "Acheter CNYT",
  yqfy: "Commission d'invitation",
  hbthhr: "Partenaire HBT",
  tczh: "Déconnexion",
  moreNew: "Plus d'annonces",
  gfgg: "Annonces officielles",
  zxxw: "Dernières actualités",
  ckgd: "Voir plus",
  bbdd: "Ordres Spot",
  bbwhydd: "Ordres Futures perpétuels à marge de devise",
  etfdd: "Ordres ETF",
  fbdd: "Ordres Fiat",
};

const recommend = {
  vol24h: "Volume 24h",
  jyd: "Paire de trading",
  jydlx: "Type de paire",
  zxj: "Dernier prix",
  change24: "Variation 24h",
  line24: "Tendance des prix (3j)",
};

const hyy = {
  bkt: "Ne pas activer",
  wqdkt: "Je confirme l'activation",
  kt12: "1. Vous devez comprendre en détail les connaissances de base et les risques liés au trading de contrats sur actifs numériques ainsi que toutes les règles commerciales relatives aux transactions sur produits dérivés avant d'y participer.",
  kt13: "2. Cette déclaration de risques n'est qu'une énumération et ne liste pas de manière exhaustive tous les facteurs de risque liés au trading de produits dérivés sur actifs numériques. Les investisseurs doivent également comprendre et maîtriser les autres risques potentiels avant d'investir dans ce type de trading.",
  kt14: "3. Nous vous conseillons sincèrement de décider prudemment de participer ou non à ce trading de contrats en fonction de votre propre situation (tolérance au risque, etc.) et de configurer rationnellement vos actifs numériques.",
  kt0: "Cher utilisateur :",
  kt1: "Vous n'avez pas encore activé le compte Futures et les autorisations de trading associées. Veuillez lire attentivement ce qui suit avant de décider d'activer :",
  kt2: "1. Si vous tradez sur le marché des contrats à terme et que l'évolution des prix vous est défavorable, entraînant une marge de position insuffisante, le contrat perpétuel BiKing exécutera une liquidation forcée de votre position selon les règles du système et divulguera les détails de la liquidation.",
  kt3: "2. Vous devez lire attentivement et respecter les règles commerciales du contrat perpétuel BiKing, comprendre le mécanisme et le principe de fonctionnement du contrat, ainsi que les différents risques du marché.",
  kt4: "4. Le contrat perpétuel BiKing est connecté au système de trading de contrats. Les bénéfices/pertes de la position de l'utilisateur fluctuent avec les mouvements du marché. En cas de perte importante, une liquidation peut également se produire. L'utilisateur doit prendre ses propres décisions de trading en fonction de la situation du marché et assumer ses propres bénéfices/pertes. En conséquence, BiKing n'offre aucune garantie implicite ou explicite.",
  kt5: "5. Veuillez respecter consciemment les règles de la plateforme et les lois/réglementations des pays/régions concernés. Si votre compte Futures est anormal en raison d'opérations non conformes, le compte sera gelé et vous ne pourrez plus effectuer d'opérations. La plateforme ne pourra pas non plus exécuter la liquidation pour vous. En cas de perte ou de liquidation, la plateforme n'assumera aucune responsabilité.",
  kt6: "6. Le trading de produits dérivés sur actifs numériques peut être soumis à des risques réglementaires dans certaines juridictions. Vous devez juger prudemment après avoir compris le contexte réglementaire de votre zone de trading. En raison de changements légaux/réglementaires, de modifications des règles de la bourse de contrats ou de mesures d'urgence, BiKing publiera une déclaration préalable. Vos positions ouvertes pourraient ne pas pouvoir être maintenues, mais les marges et les bénéfices restants seront tout de même réalisés.",
  kt7: "7. En raison de circonstances indépendantes de la volonté de la plateforme (catastrophes naturelles, pannes informatiques, etc.), vos ordres pourraient ne pas être exécutés ou partiellement exécutés. Les pertes qui en résultent pourraient être à votre charge.",
  kt8: "8. Le trading de couverture, tout comme le trading spéculatif, est également confronté aux risques liés aux fluctuations des prix.",
  kta9: "9. Si vous n'avez pas effectué de vérification d'identité ou lié Google Authenticator, ou si vous prêtez votre compte à des tiers, la sécurité de votre marge de contrat pourrait être affectée.",
  kta10:"3. Dans certaines conditions de marché extrêmes, il peut être difficile, voire impossible, de liquider vos positions ouvertes. Par exemple, si votre bénéfice se classe premier en termes de PnL à effet de levier sur l'ensemble du marché et que la contrepartie ne dispose pas de suffisamment de fonds dans le fonds d'assurance pour couvrir sa perte de liquidation.",
  kt9: "J'ai lu attentivement et j'accepte les risques",
  kt10: "Activer le compte Futures et les autorisations",
  zjhz: "Transfert de fonds",
  ljhz: "Transférer",
  qx: "Annuler le transfert",
  khz: "Transferable",
  qxz: "Sélectionner",
  bz: "Devise",
  c: "De",
  zz: "Vers",
  sl: "Quantité",
  qb: "Tout",
  ktcg: "Activation réussie",
  ktsb: "Échec de l'activation",
  hzcg: "Transfert réussi",
  hzsb: "Échec du transfert",
  wyyd: "",
  tc: "Quitter",
  warning1: "Veuillez sélectionner une devise",
  warning2: "Le compte source ne peut pas être vide",
  warning3: "Le compte destinataire ne peut pas être vide",
  warning4: "Veuillez entrer un nombre ne dépassant pas le montant transférable",
  warning5: "Maximum 4 décimales",
  gb: "Fermer",
  openSuccess: "Vous avez activé le trading de contrats",
  openSuccessTip: "Veuillez transférer des fonds vers votre compte Futures",
  wsmyz: "Vous n'avez pas encore effectué la vérification d'identité",
  hdnm: "Effectuez la vérification d'identité et un transfert net cumulé de [*] USDT pour recevoir [**] USDT de jetons non négociables (Non-Negotiable Tokens - NNT)",
  nmjl: "Historique des NNT",
  nmhzjl: "Historique des NNT reçus",
  gxn: "Félicitations !",
  qwjy: "Aller au trading",
  yfrndhyzh: "Déposé dans votre compte Futures",
  nzxy: "Il vous suffit de transférer [*] USDT supplémentaires vers votre compte Futures pour recevoir [**] USDT de NNT",
  nmssm: "Qu'est-ce qu'un NNT ?",
  nm: "NNT",
  nxhyzh: "Vous vers votre compte Futures",
  text1: "Transfert net cumulé de [*] USDT ou plus vers le compte Futures pour recevoir",
  text2: "Il vous suffit de transférer [*] USDT supplémentaires vers votre compte Futures",
  text3: "pour recevoir [*] USDT de NNT",
  text4: "Solde",
  text5: "Vous avez transféré net cumulé de [*] USDT ou plus vers le compte Futures, vous avez déjà reçu",
  not_get_nm: "Désolé, l'offre NNT est terminée, ce transfert n'a pas donné lieu à des NNT.",
  yijie: "1. Niveau 1",
  erjie: "2. Niveau 2",
  ljjhr: "Transfert net cumulé",
  khd: "Recevable",
  hysnm: "NNT sur Futures",
  bbgg: "Contrat perpétuel, effet de levier 100x",
  hdsj: "Période de l'offre :",
  hdxq: "Détails de l'offre",
  ljhd: "Recevoir",
  xdxd: "Premier arrivé, premier servi",
  ylnnz: "Gagnez, vous repartez avec ; perdez, c'est pour nous.",
};

const Verification = {
  channel: "Canal de vérification officiel",
  verify: "Veuillez entrer les informations à vérifier",
  notes: "Conseils de sécurité",
  notes1:"1. Tous les e-mails, comptes WeChat, QQ, domaines et comptes média liés à BiKing peuvent être vérifiés ici.",
  notes2: "2. Les comptes de réseaux sociaux (Weibo, Twitter, etc.) prennent uniquement en charge la recherche par nom, sensible à la casse.",
  notes3: "3. En cas de doute sur le résultat de la vérification, veuillez contacter le service client officiel sur le site Web ou dans l'application pour une confirmation supplémentaire.",
  error: "Échec de la vérification",
  error1: "Les informations que vous avez vérifiées",
  error2: "ne sont pas un canal officiel certifié. Veuillez protéger la sécurité de vos actifs et éviter les fuites d'informations personnelles.",
  errorNote: "Remarques",
  errorNote1:"1. Actuellement, le canal de vérification officiel ne prend en charge que la vérification des e-mails, des comptes WeChat officiels, des QQ, des domaines et des comptes de réseaux sociaux.",
  errorNote2: "2. Les outils de chat comme WeChat ne prennent en charge que la recherche par nom de compte (pas par pseudonyme).",
  errorNote3: "3. Les comptes de réseaux sociaux ne prennent en charge que la recherche par nom, sensible à la casse.",
  success: "Vérification réussie",
  success1: "Les informations que vous avez vérifiées :",
  success2: "sont certifiées officiellement par BiKing",
  success3: ". Si ce numéro/compte apparaît sur d'autres canaux, il n'est pas fiable. Veuillez assurer la sécurité de vos actifs.",
  more: "Voir plus",
  know: "Je comprends",
  weChat: "WeChat",
  name: "Domaine",
  webo: "Weibo",
  twitter: "Twitter",
  email: "E-mail",
  contact: "Contacter le service client",
  bannerTip:"Pour éviter que des fraudeurs n'utilisent le nom de BiKing pour escroquer, vous pouvez utiliser cette page pour confirmer si les appels téléphoniques, WeChat, etc. qui vous contactent sont des canaux officiels de BiKing.",
};
const index = {
  downloadIos: 'Télécharger sur AppStore',
  downloadAndroid: 'Télécharger Android',
  downloadGoogle: 'Télécharger Google Play'
};

const indexPage = {
  gfgg: "Annonces officielles",
  zxxw: "Dernières actualités",
  ckgd: "Voir plus",
};

const NAVS = {
  ty: 'Coupe d Europe',
  hqsj: 'Marché',
  game: 'Jeux',
  fx: 'Découvrir',
  sj: 'Données',
  fb: "Acheter crypto",
  bb: "Trading Spot",
  jr: "Finance",
  jyds: "Concours de trading",
  hbhd: "Activité enveloppes rouges",
  gg: "Trading sur marge",
  yxhy: "Contrat perpétuel",
  eft: "Trading ETF",
  flhd: "Activités de récompenses",
  flzx: "Centre de récompenses",
  fast: "Trading rapide",
  spec: "Trading pro",
  login: "Connexion",
  rig: "Inscription",
  downapp: "Télécharger l'application BiKing",
  downappsum: "Expérience fluide, dépôts/retraits rapides",
  zichan: "Actifs",
  order: "Ordres",
  qbhz: "Transfert entre portefeuilles",
  lang: "Langue",
  calc: "Méthode de valorisation",

  mb: "Acheter crypto",
  hq: "Marché",
  hy: "Futures",
  jy: "Trading",
  lc: "Gagner",
  fs: "Fansup",
  xy: "Académie",
  byxy: "Académie BiKing",
  byyx: "Sélection BiKing",
  coins: "Points COINS",
  gd: "Plus",
  yqhy: "Inviter des amis",
  rwzx: "Centre des tâches",
  bbms: "Achetez Bitcoin et autres actifs numériques avec USDT",
  ggms: "La plateforme prête des actifs numériques, amplifiant les gains et les risques",
  yxms: "Support effet de levier 100x, opérations pratiques et variées",
  etfms: "Amplifiez les gains, pas de risque de liquidation",
  pool: "Pool minier partagé",
  czzn: 'Guide d utilisation',
  gywm: 'À propos de nous',
  zhxx: 'Informations du compte',
  gd:"Copie de trading Futures",
  yxhy: "Contrat perpétuel",
  zjhy: "Contrat bonus",
  product: "Produits",
};

const FOOTERS = {
  zxkf: "Service client en ligne",
  fawu: "Conseils juridiques",

  us: "Nous",
  product: "Produits",
  service: "Services",
  college: "Apprendre",

  aboutUs: "À propos",
  rateSum: "Frais",
  notices: "Centre d'annonces",
  helps: "Centre d'aide",
  verific: "Canal de vérification officiel",
  contact: "Nous contacter",

  fabi: "Acheter crypto",
  bibi: "Trading Spot",
  ganggan: "Trading sur marge",
  swiper: "Contrat perpétuel",
  etf: "Trading ETF",
  licai: "Gagner",

  apis: "Support API",
  apisNew: "Support API",
  addCoin: "Demande de cotation",
  vips: "Avantages VIP",
  downapp: "Télécharger l'application",
  files: "Documents légaux",

  newuser: "Académie débutant BiKing",
  swiperSchool: "Académie des contrats",
  assistant: "Assistant d'apprentissage",
  digitalintroduction: "Présentation des actifs numériques",

  watchword: "Plateforme de trading verte de classe mondiale",
  meiyitian: "Chaque jour, faites prospérer votre patrimoine",
  chat: "Salon de discussion",
  shequncn: "Communauté Telegram chinoise",
  shequnen: "Communauté Telegram anglaise",
  shequnkr: "Communauté Telegram coréenne",
};

const SIDEBAR = {
  newuser: "Débutant",
  guide: "Guide",
  bbsq: "Communauté Spot",
  hysq: "Communauté Futures",
  gd: "Fixé",
  sq: "Réduire",
};

const banner = {
  wzwh: 'En utilisant le site Web de Biking et/ou en gérant votre compte, vous acceptez notre mise à jour des',
  sytk: 'Conditions d utilisation',
  yszc: 'Politique de confidentialité',
  hh: 'et',
  cookie: 'Politique en matière de cookies',
  djgb: 'En cliquant sur "X", vous reconnaissez avoir lu et accepté les termes et politiques ci-dessus.',

  title: 'Plateforme diversifiée de jeux et de trading de cryptomonnaies',
  marketTitle: 'Le trading de cryptomonnaies, nous sommes experts',
  marketSubTitle: 'Dédiée à fournir aux utilisateurs des services de trading de produits dérivés sur actifs numériques plus sûrs et stables',
  pathTitle: 'Votre assistant fiable pour votre voyage dans les cryptomonnaies',
  pathSubTitle: 'Le choix de millions d utilisateurs, une plateforme digne de confiance',
  jylz: '300 milliards USD',
  jyl: 'Volume de trading sur 72 heures',
  sxs: 'Cryptomonnaies listées',
  zcyh: 'Utilisateurs enregistrés',
  zdjy: 'Frais de trading les plus bas',
  connectTitle: 'Pourquoi nous choisir',
  connectSubTitle: 'BiKing vous aide à créer, valoriser et préserver votre patrimoine',
  advantageText1: 'Performance ultime · Trading ultra-rapide',
  advantageSubText1: 'Technologie du London Stock Exchange, faible latence, exécution ultra-rapide',
  advantageText2: 'Sécurité des actifs · Protection maximale',
  advantageSubText2: 'BiKing est conforme aux normes CCSS, garantissant la sécurité des actifs et des données',
  advantageText3: 'Haute liquidité · Faible spread',
  advantageSubText3: 'Trading à effet de levier sur contrats BiKing, haute efficacité, glissement minimal',
  advantageText4: 'Service 24/7',
  advantageSubText4: 'Disponibilité garantie du système, service client 24h/24',
  advantageText5: 'Facile à utiliser',
  advantageSubText5: 'Divers systèmes d ordres et outils de trading, risques contrôlables',
  advantageText6: 'N importe où, n importe quand · Trading serein',
  advantageSubText6: 'Plateforme BiKing disponible sur le Web, l application mobile, l API et la connexion FIX',
  netWorkTitle: 'Le choix de 1,2 million d utilisateurs dans 26 pays',
  netWorkSubTitle: 'Dédiée à fournir aux utilisateurs des services de trading de produits dérivés sur actifs numériques plus sûrs et stables',
  smxz: 'Scanner pour télécharger',
  fxbzj: 'Fonds de risque',
  fkbz: 'Chaque transaction bénéficie d une protection complète des risques de fonds',
  question1: '1. Présentation de BiKing Exchange',
  questionContent1: 'BiKing Exchange est une plateforme mondiale de trading d actifs numériques basée à Singapour, titulaire de licences MSB aux États-Unis et au Canada, proposant des services de trading, de stockage et de gestion de divers actifs numériques.',
  question2: '2. Quels produits propose BiKing Exchange ?',
  questionContent2: 'BiKing Exchange propose : Contrats perpétuels (profondeur, exécution rapide), Trading Spot (0 frais, exécution rapide), Copie de trading (traders expérimentés, stratégies stables), Trading bonus (modèle unique, récompenses continues), Portefeuille Web (services décentralisés tout-en-un).',
  question3: '3. Comment s inscrire sur BiKing Exchange ?',
  questionContent3: 'Vous pouvez vous inscrire sur le site officiel de BiKing Exchange ou via l application BiKing. Cliquez sur "S inscrire" et suivez le processus pour commencer à investir dans les cryptomonnaies sur BiKing Exchange.',
  question4: '4. Comment acheter des cryptomonnaies via BiKing Exchange ?',
  questionContent4: 'L achat rapide de BiKing Exchange prend en charge plusieurs méthodes de paiement et devises fiduciaires, offrant plus de choix et de commodité aux utilisateurs du monde entier, leur permettant d acheter facilement des cryptomonnaies avec leur monnaie locale.',
  question5: '5. Comment trader des actifs numériques ?',
  questionContent5: 'Vous pouvez sélectionner l actif numérique souhaité sur BiKing Exchange, accéder à la page de trading, choisir d acheter ou de vendre, saisir la quantité et le prix, et confirmer la transaction. BiKing Exchange prend en charge le trading de nombreux actifs numériques comme Bitcoin, Ethereum, Litecoin, Ripple, etc.',
  question6: '6. Comment BiKing Exchange protège-t-il la sécurité des actifs des utilisateurs ?',
  questionContent6: 'BiKing Exchange utilise une technologie de cryptage multicouche pour protéger les informations des utilisateurs et les actifs, et stocke les actifs via une séparation entre portefeuilles chauds et froids pour garantir la sécurité des actifs des utilisateurs.',

  investor: '300W d investisseurs en cryptomonnaies font confiance',
  transaction: 'Investissez, tradez et grandissez avec BiKing',
  hypt: 'Plateforme de trading de contrats d actifs numériques leader mondial en sécurité',
  yjpc: 'Ouvrez et fermez des positions en un clic',
  jscrj: 'Dépôts et retraits ultra-rapides, commencez à trader en 60 secondes, zéro glissement',
  zcpt: 'Inscrivez-vous et tradez pour recevoir des USDT',
  email: 'Adresse e-mail',
  phone: 'Numéro de téléphone',
  zc: 'S inscrire',
  yhjaqbz: 'Sécurité de niveau bancaire',
  lhdmch: 'Exécution instantanée, zéro glissement',
  qthkf: 'Service client 7j/7, 24h/24',
  rmjmhb: 'Cryptomonnaies populaires',
  jrsq: 'Rejoignez la communauté Biking',
  hqzxhd: 'Recevez les dernières actualités des activités Biking et un support en ligne',
}
const navCard = {
  join: 'Rejoignez BiKing',
  hzdl: 'BiKing recherche des partenaires agents, rejoignez-nous !',
  jmrx: 'Ligne directe agent : 183283232998',
  contract: 'Contrat en ligne',
  yxhy: 'Double contrat surprise sur BiKing',
  jylh: 'Trading plus flexible, revenus plus riches',
  usa: 'USA ET CANADA MSB',
  zmjys: 'BiKing, bourse mondiale renommée, obtient des licences conformes dans plusieurs pays',
  fxpf: 'Risque indemnisé, sécurité et confiance',
  srhy: 'BiKing offre 30% de bonus en vrai sur les contrats',
  hdsj: 'Période : du 01/11/2022 00:00 au 01/12/2022 00:00'
}

const choice = {
  gjyh: 'Le choix de 1,2 million d utilisateurs dans 26 pays',
  jyfu: 'Dédiée à fournir aux utilisateurs des services de trading de produits dérivés sur actifs numériques plus sûrs et stables',
  wsmxzwm: 'Pourquoi nous choisir',
  jsty: 'Expérience ultra-rapide',
  jmsj: 'L interface de trading combine l expérience utilisateur de la plateforme, processus clairs, opérations pratiques, et une technologie de correspondance en mémoire microseconde pour une expérience de trading plus confortable.',
  kfx: 'Mécanisme de prix anti-risque',
  pthybz: 'Le prix des devises sur la plateforme utilise un algorithme intégré multi-sources, offrant une forte capacité de contrôle des risques, évitant efficacement les risques et pertes des utilisateurs dus aux fluctuations extrêmes du marché.',
  zjaqbz: 'Garantie de sécurité des fonds',
  zjdt: 'Toutes les dynamiques de fonds sont complétées par des signatures hors ligne multiples, garantissant un jugement microseconde, un stockage profond à froid des actifs, protégeant pleinement la sécurité des fonds des utilisateurs.',
  jszc: 'Support technique de pointe',
  ptjstd: 'L équipe technique est composée d experts blockchain de premier plan, garantissant une expérience utilisateur optimale et fournissant un support technique puissant pour le développement et l exploitation de la plateforme.',
  jcjz: 'Mécanisme de réduction progressive des positions',
  hqbh: 'En fonction des changements du marché, le mécanisme de contrôle des risques est déclenché de manière appropriée pour protéger les biens des utilisateurs 24h/24.',
  kf: 'Service client 24h/24',
  ptkf: 'La plateforme dispose d un service client 24h/24, traitant sérieusement chaque problème rencontré par les utilisateurs.'
}

const plat = {
  ptgn: 'Fonctionnalités de la plateforme',
  zjms: 'Mode bonus',
  zjjs: 'Le mode bonus est une nouvelle fonctionnalité de contrat lancée par l équipe BiKing pour les utilisateurs de contrats. Le processus est identique à celui du contrat réel. La partie bénéficiaire des positions ouvertes peut être transférée vers le compte Futures pour continuer à ouvrir des positions ou être retirée directement. Obtenu via : remboursement en temps réel des frais, airdrops d activités, accomplissement de tâches, etc.',
  zcms: 'Mode Croix (Cross)',
  zcjs: 'En mode croix, les marges et les bénéfices/pertes flottants de toutes les positions sont interconnectés. Tous les actifs du compte, y compris la marge d ouverture, servent de marge flottante. Ce mode offre une forte capacité de contrôle des risques, mais en cas de fluctuations violentes du marché, les pertes peuvent dépasser les attentes.',
  zucms: 'Mode Isolé (Isolated)',
  zucjs: 'En mode isolé, chaque ordre est indépendant. Les bénéfices/pertes sont calculés séparément en fonction du prix d ouverture de chaque position. Si la perte atteint le point de stop-loss maximum, la position est liquidée de force. Au point de take-profit maximum, la position est automatiquement fermée. S il y a des positions ouvertes ou des ordres planifiés en mode isolé, vous ne pouvez pas passer en mode isolé pour ouvrir une nouvelle position.',
  gdgn: 'Fonction de copie de trading',
  gdjs: 'Une fois la fonction de copie activée, toutes les actions d ouverture et de fermeture du trader copié seront exécutées en synchronisation, sauf en cas de solde insuffisant ou de dépassement de la limite de position. Si vous n annulez pas manuellement la fonction de copie, elle restera activée.',
  bfpc: 'Fermeture partielle',
  bfjs: 'Lorsque vous détenez une certaine quantité de positions longues ou courtes, vous pouvez librement sélectionner le montant à fermer en fonction de l évolution du marché et des bénéfices/pertes. Le montant des bénéfices/pertes de la position sera réglé proportionnellement au montant fermé et à la marge totale. Les bénéfices flottants restent inchangés après la fermeture.',
  fxkc: 'Ouverture en sens inverse',
  fxjs: 'Le système fermera automatiquement la position sélectionnée au meilleur prix du marché et ouvrira une position en sens inverse de même quantité, afin d éviter de manquer un retournement de marché.',
  zjbzj: 'Ajout de marge',
  zjbzjjs: 'Lorsque vous détenez des positions longues ou courtes, vous pouvez ajouter de la marge tout en respectant les paramètres actuels. Le coefficient de la position après ajout sera calculé par une formule pondérée en fonction des paramètres de position lors de l ouverture et de l ajout de marge.'
}

const risk = {
  fxbzj: 'Fonds de risque',
  fxbz: 'Chaque transaction bénéficie d une protection complète des risques de fonds'
}

const license = {
  license: 'BiKing obtient une licence MSB',
  hgyy: 'Opération conforme, présence mondiale',
  login: 'Connexion',
  download: 'Scanner pour télécharger BiKing',
  support: 'Support',
  jsjy: 'Tradez à tout moment, exécution ultra-rapide',
  ljxz: 'Télécharger l application BiKing'
}

const footer = {
  yhyh: 'La plateforme de contrats la plus',
  jypt: 'conviviale pour les utilisateurs',
  yhzc: 'Support utilisateur',
  flsm: 'Frais',
  ggzx: 'Centre d annonces',
  yhxz: 'Avis aux utilisateurs',
  tksm: 'Conditions',
  fxzs: 'Avertissement sur les risques',
  xylb: 'Liste des accords',
  gywm: 'À propos',
  gy: 'À propos',
  lxwm: 'Nous contacter',
  appxz: 'Télécharger l application',
  callus: 'S abonner à BiKing Genesis',
  zwzxxx: 'Recevez les dernières nouvelles, analyses et fluctuations de prix',
  zc: 'S inscrire',
  email: 'Adresse e-mail',
  callingus: 'Nous contacter',
  bqsy: 'Tous droits réservés',
  tips: 'Note : Investir comporte des risques, la prudence est de mise'
}

const card = {
  title: 'Pourquoi sommes-nous la plateforme de contrats la plus conviviale ?',
  text: 'BiKing vous aide à créer, valoriser et préserver votre patrimoine',
  djxn: 'Remboursement des frais',
  jsqd: 'Remboursement en temps réel de 100% des frais, réduisant considérablement les coûts de trading et augmentant les opportunités de profit.',
  zcbz: 'Dépôts et retraits ultra-rapides',
  cssbz: 'Dépôts et retraits fluides, garantissant la sécurité des fonds des utilisateurs tout en ne manquant aucune opportunité de trading.',
  gld: 'Facile à utiliser',
  zxhd: 'Inscription et ouverture de position en seulement 10 secondes. Un système de sécurité unique protège la vie privée des utilisateurs. Processus d inscription simplifié.',
  qthfw: 'Service 24/7',
  kffw: 'Interface confortable et fluide. Marge en devise de base. Service client en ligne 24h/24, réponses en temps réel aux questions de trading.',
  bjyy: 'Facile à utiliser',
  fxkk: 'Divers systèmes d ordres et outils de trading, risques contrôlables.',
  axjy: 'N importe où, n importe quand · Trading serein',
  bkms: 'Plateforme BiKing disponible sur le Web, l application mobile, l API et la connexion FIX.'
}

const news = {
  title: 'Actualités & Perspectives',
  text: 'Découvrez les dernières nouvelles et les spécificités de la principale bourse de cryptomonnaies au monde.',
  sy: 'Perspectives',
  ltitle: 'Bitcoin peut-il résoudre les défis uniques des marchés émergents ?',
  ldesc: 'Cet article a initialement été publié sur Cointelegraph. Alors que le Blockchain Economy Istanbul Summit se concentre sur le développement des marchés émergents, l adoption de Bitcoin continue d être motivée par la demande au cas par cas ?…',
  more: 'En savoir plus',
  xwfbs1: 'Salle de presse',
  rdesc1: 'La bourse d actifs numériques BiKing sponsorise le Blockchain Economy Istanbul Summit 2022',
  xwfbs2: 'Salle de presse',
  rdesc2: 'La bourse d actifs numériques BiKing sponsorise le Blockchain Economy Istanbul Summit 2022',
}

const info = {
  hzhb: 'Partenaires plateformes de trading automatisé',
  qsjy: 'Tradez facilement sur BiKing avec des robots de trading',
  quadency: 'QUADENCY',
  clpt: 'Plateforme de stratégies de trading automatique professionnelle',
  stacked: 'Stacked',
  glcf: 'Les utilisateurs peuvent investir dans des indices cryptos avec Stacked, effectuer des transactions automatisées et gérer leur patrimoine.'
}
const menu = {
  creditCardOrder: 'Ordres de paiement',
  ptmb: 'C2C',
    dsfjy: 'Trading tiers',
  kjmb: 'Achat rapide',
  xykmb: 'Achat par carte de crédit',
  order: 'Ordres',
  userOrder: 'Ordres utilisateur',
  merchantOrder: 'Ordres commerçant',
  quickOrder: 'Ordres rapides',
  merchant:'Commerçant',
  asMerchant:'Devenir commerçant',
  advertisingManage: 'Gestion des annonces',
  financialStatements: 'États financiers',
  messageCenter: 'Centre de messages',
  more: 'Plus',
  paymentSettings: 'Paramètres de paiement',
  publish: 'Publier une annonce',
  overview: 'Aperçu',
  aqzx: 'Centre de sécurité',
  phsz: 'Préférences',
  hykhj: 'Saison des contrats, nouvelle ère de trading',
  xszn: 'Guide du débutant',
  bwyjy: 'Institut BiKing',
  bwsq: 'Communauté BiKing',
  yhxz: 'Avis aux utilisateurs',
  bwysp: 'Produits dérivés BiKing',
  jyxz: 'Avis sur les transactions OTC'
}
const otc = {
  Realtimequotes:'Les cotations en temps réel sont fournies à titre indicatif uniquement. Veuillez vous référer aux prix sur la page du fournisseur de services tiers.',
  Realtimequotes1:'Limite par transaction',
  Realtimequotes2:'Prix de référence',
  Realtimequotes3:'Acheter',
  Realtimequotes5:'Veuillez entrer le montant à acheter',
  Realtimequotes6:'Max',
  Realtimequotes7:'Dépasse la limite maximale',
  Realtimequotes8:'Quantité',
  Realtimequotes9:'Frais',
  Realtimequotes10:'Mode de paiement',
  Realtimequotes11:'Délai de réception',
  Realtimequotes12:'10 à 20 minutes après le paiement réussi',
  Realtimequotes13:'Confirmer l achat',
  Realtimequotes14:'Étapes d achat',
  Realtimequotes15:'Sélectionnez la cryptomonnaie, la devise fiduciaire et le fournisseur de services',
  Realtimequotes16:'Entrez le montant, remplissez les informations sur le site du fournisseur tiers et effectuez le paiement',
  Realtimequotes17:'Consultez la cryptomonnaie achetée dans l historique des dépôts BiKing et les détails de la commande sur le site du fournisseur',
  Realtimequotes18:'Vous allez être redirigé vers {XXXXX} pour effectuer l achat',
  Realtimequotes24:'Note importante',
  Realtimequotes19:'{XXXXX} est une plateforme de trading de devises fiduciaires/cryptomonnaies exploitée indépendamment par un tiers. Tous les services associés sont fournis par {XXXXX}.',
  Realtimequotes20:'Le prix de référence inclut les frais de la plateforme. Le prix réel de transaction est basé sur le prix du site officiel de {XXXXX}.',
  Realtimequotes21:'BiKing n est en aucun cas responsable des pertes ou dommages subis lors de l utilisation de ce service.',
  Realtimequotes22:'J ai compris, j y vais',
  Realtimequotes23:'Montant de l achat',
  Realtimequotes25:'Trading tiers',
  Realtimequotes26:'Veuillez d abord compléter vos informations d e-mail',
  Realtimequotes27:'Compléter maintenant',
  Realtimequotes28:'Nom du commerçant tiers',
  XXXXX:'{pay} est une plateforme de trading de devises fiduciaires/cryptomonnaies exploitée indépendamment par un tiers. Tous les services associés sont fournis par {pay}.',
  XXXX:'Le prix de référence inclut les frais de la plateforme. Le prix réel de transaction est basé sur le prix du site officiel de {pay}.',
  ckj: 'Prix de référence ({price})',
  meBuy: 'Je veux acheter',
  服务商: 'Fournisseur',
  bjgq: 'Cette cotation a expiré, veuillez en obtenir une nouvelle',
  gxbj: 'Mettre à jour la cotation',
  zxkdh: 'Minimum échangeable {min} {symbol}',
  zdkdh: 'Maximum échangeable {max} {symbol}',
  Available: 'Solde disponible',
  Unknown: 'Inconnu',
  qxgz: 'Règle d annulation : 200 annulations par jour pour un acheteur entraîneront la suspension de la fonction d achat pour la journée.',
  xncs: 'vous vend',
  qxzzffs: 'Veuillez sélectionner un mode de paiement',
  qdqx: 'Confirmer l annulation',
  wzxx: 'Je vais réfléchir',
  msk: 'Mode de réception de l acheteur',
  zhmc: 'Nom du compte',
  zhxq: 'Détails du compte',
  xzhb: 'Sélectionner la devise',
  
  buyer: 'Acheteur',
  seller: 'Vendeur',
  goSet: 'Ajouter',
  addPayWayTitle: 'Ajouter un mode de réception',
  addPayWay: 'Vous devez ajouter ou activer au moins un mode de réception pour {type} des cryptomonnaies',
  supportPayWay: 'Vous devez ajouter et activer les modes de réception pris en charge pour {type}',
  top: 'Épingler',
  marginTips: 'Vous avez payé {baseMarginPaid} USDT de marge. Vous devez encore payer au moins {needMargin} USDT.',
  eyqx: '3 annulations ou réclamations par jour entraîneront une restriction. En cas d annulation malveillante avérée, le compte sera gelé. Agissez avec prudence !',
  qdbzgm: 'Êtes-vous sûr de ne plus vouloir acheter ?',
  qxbtk: 'L annulation de la commande n entraînera pas de remboursement. Si vous avez déjà payé, veuillez ne pas annuler la commande.',
  yzjbzj: 'Le commerçant standard a ajouté de la marge',
  xbjjcbzj: 'Marge de base supplémentaire requise',
  jg: 'Prix',
  zxjgxd: 'Passer l ordre au prix actuel',
  je: 'Montant',

  ccxe: 'Hors limite',
  yebz: 'Solde insuffisant',
  qxsm: 'Veuillez d abord vérifier votre identité',

  dfb: 'En attente de libération',
  jywc: 'Transaction terminée',
  buy: 'Acheter',
  sell: 'Vendre',
  coin: 'Devise',
  allCoin: 'Toutes les devises',
  frenchCurrency: 'Fiat',
  payWay: 'Mode de paiement',
  all: 'Tous',
  bankCard: 'Carte bancaire',
  zfb: 'Alipay',
  wx: 'WeChat',
  search: 'Rechercher',
  merchant: 'Commerçant (commandes/ taux de réussite 30j)',
  turnover: 'Volume',
  completionRate: '% taux de réussite',
  quotaOrNumber:'Quantité/Limite',
  number: 'Quantité',
  quota: 'Limite',
  price: 'Prix unitaire',
  paymentMethod: 'Mode de réception',
  trade: 'Transaction',
  handlingFee: '0 frais',
  buyUsdt: 'Acheter USDT',
  sellBtc: 'Vendre USDT',
  theRemainingAmount: 'Quantité restante',
  userRealName: 'Nom réel de l utilisateur',
  businessMessage: 'Message du commerçant',
  wantPay: 'Je veux payer',
  wantSell: 'Je veux vendre',
  receive: 'Je recevrai',
  password: 'Mot de passe',
  pleaseEnterPassword: 'Veuillez entrer le mot de passe',
  cancel: 'Annuler',
  buyUSDT: 'Acheter USDT',
  sellUSDT: 'Vendre USDT',
  Paymentchannel :'Canal de paiement (veuillez vous référer au taux de change du fournisseur de services).',
  lumpSum: 'Montant total',
  agree: 'En acceptant de faire du trading C2C avec BiKing, vous acceptez',
  mzsm: 'la clause de non-responsabilité légale du trading C2C de BiKing',
  quit: 'Quitter',
  confirm: 'Confirmer',
  orderDetail: 'Détails de la commande',
  limitExceeded: 'Limite dépassée',
  quantityRemaining: 'Quantité restante insuffisante',

  cryptoTitle: 'Achetez USDT facilement en quelques étapes',
  cryptoSubTitle: 'Plateforme de trading de contrats d actifs numériques leader mondial en sécurité',
  availableBalance: 'Solde disponible',
  sellAll: 'Tout vendre',
  fundsTransfer: 'Transfert de fonds',
  threeStep: 'Acheter des cryptos en 3 étapes',
  advantage: 'Avantages d acheter/vendre des cryptomonnaies avec BiKing',
  commonQuestion: 'Questions fréquentes',
  otc_title: 'Utilisez le C2C pour acheter/vendre des cryptomonnaies à 0 frais',
  otc_title1: 'Tradez sur BiKing en toute sécurité et simplicité avec des frais nuls. Tradez USDT immédiatement par virement bancaire, carte de crédit et plus encore.',
  commonQuestion1: 'Qu est-ce que le trading C2C de cryptomonnaies ?',
  commonQuestion2: 'Combien coûte le trading C2C ?',
  commonQuestion3: 'Que sont les commerçants sur le C2C de BiKing ?',
  commonQuestion4: 'Les commerçants C2C de BiKing sont-ils rentables ?',
  commonQuestion5: 'Comment éviter les fraudes C2C ?',
  commonQuestion1_desc: 'Le C2C crypto désigne les transactions de pair à pair où vous tradez directement des cryptomonnaies entre vous, sans intermédiaire comme une bourse centralisée.',
  commonQuestion2_desc: 'Le coût du trading C2C peut varier considérablement selon la plateforme, la cryptomonnaie et la congestion du réseau. Cependant, BiKing C2C facture 0 frais pour les transactions de cryptomonnaies, sans intermédiaire.',
  commonQuestion3_desc: 'Les commerçants sur le C2C BiKing sont des utilisateurs certifiés qui peuvent publier des annonces et effectuer des transactions avec d autres utilisateurs.',
  commonQuestion4_desc: 'La rentabilité des commerçants C2C BiKing dépend de multiples facteurs, notamment leur stratégie de trading, leur fréquence de transaction, l écart acheteur/vendeur et les conditions générales du marché.',
  commonQuestion5_desc: 'Pour vous prémunir contre les fraudes C2C, vérifiez l identité de la contrepartie, utilisez une plateforme sécurisée, limitez le partage d informations personnelles/financières et utilisez des modes de paiement traçables.',
  register: 'S inscrire',
  registerByPhone: 'S inscrire par e-mail ou téléphone',
  authentication: 'Vérification d identité',
  authenticationId: 'Effectuez la vérification d identité, uniquement avec une pièce d identité',
  buyCoins: 'Acheter des cryptos',
  buyCoinsByCard: 'Acheter des cryptos par carte de crédit/débit ou virement bancaire',
  fast: 'Rapide et pratique',
  easyUse: 'Achat de cryptos simple',
  fastPayment: 'Rapide, seulement quelques minutes.',
  multiplePayment: 'Plusieurs modes de paiement',
  platformSupports:'La plateforme prend en charge plusieurs modes de paiement',
  flexibleConvenient: 'Offre plus de flexibilité et de commodité aux utilisateurs.',
  safeReliable: 'Sûr et fiable',
  measure: 'Utilise plusieurs technologies et mesures de sécurité',
  informationSecurity: 'Garantit la sécurité des fonds et des informations des utilisateurs.',
  questionTitle1: '1. Présentation de BiKing Exchange',
  questionSubTitle1: 'BiKing Exchange est une plateforme mondiale de trading d actifs numériques basée à Singapour, titulaire de licences MSB aux États-Unis et au Canada, proposant des services de trading, de stockage et de gestion de divers actifs numériques.',
  questionTitle2: '2. Quels produits propose BiKing Exchange ?',
  questionSubTitle2: 'BiKing Exchange propose : Contrats perpétuels (profondeur, exécution rapide), Trading Spot (0 frais, exécution rapide), Copie de trading (traders expérimentés, stratégies stables), Trading bonus (modèle unique, récompenses continues), Portefeuille Web (services décentralisés tout-en-un).',
  questionTitle3: '3. Comment s inscrire sur BiKing Exchange ?',
  questionSubTitle3: 'Vous pouvez vous inscrire sur le site officiel de BiKing Exchange ou via l application BiKing. Cliquez sur "S inscrire" et suivez le processus pour commencer à investir dans les cryptomonnaies sur BiKing Exchange.',
  questionTitle4: '4. Comment acheter des cryptomonnaies via BiKing Exchange ?',
  questionSubTitle4: 'L achat rapide de BiKing Exchange prend en charge plusieurs méthodes de paiement et devises fiduciaires, offrant plus de choix et de commodité aux utilisateurs du monde entier, leur permettant d acheter facilement des cryptomonnaies avec leur monnaie locale.',
  questionTitle5: '5. Comment trader des actifs numériques ?',
  questionSubTitle5: 'Vous pouvez sélectionner l actif numérique souhaité sur BiKing Exchange, accéder à la page de trading, choisir d acheter ou de vendre, saisir la quantité et le prix, et confirmer la transaction. BiKing Exchange prend en charge le trading de nombreux actifs numériques comme Bitcoin, Ethereum, Litecoin, Ripple, etc.',
  questionTitle6: '6. Comment BiKing Exchange protège-t-il la sécurité des actifs des utilisateurs ?',
  questionSubTitle6: 'BiKing Exchange utilise une technologie de cryptage multicouche pour protéger les informations des utilisateurs et les actifs, et stocke les actifs via une séparation entre portefeuilles chauds et froids pour garantir la sécurité des actifs des utilisateurs.',
  
  orderType: 'Type d ordre',
  orderStatus: 'Statut de l ordre',
  to: 'à',
  startTime: 'Date de début',
  endTime: 'Date de fin',
  orderNo: 'Numéro de commande',
  status: 'Statut',
  totalPrice: 'Prix total',
  numberOrFee: 'Quantité/Frais',
  tradingPartners: 'Contrepartie',
  time: 'Heure',
  operate: 'Action',
  details: 'Détails',
  noPay: 'En attente de paiement',
  payed: 'Payé',
  finish: 'Terminé',
  canceled: 'Annulé',
  complaint: 'En litige',
  legalCurrency: 'Montant fiat',
  virtualCurrency: 'Cryptomonnaie',
  virtualCurrencyAddress: 'Adresse de réception',
  paymenttype: 'Type de paiement',
  creatTime: 'Date de création',
  success: 'Succès',
  pending: 'En cours',
  awaiting: 'En attente',
  declined: 'Échec',

  mjskfs: 'Mode de réception du vendeur',
  mjfkfs: 'Mode de paiement de l acheteur',
  toPay: 'Payer',
  ddzdqx: 'Si vous n avez pas choisi de mode de paiement dans {payTime}, la commande sera automatiquement annulée',
  paying: 'La contrepartie est en train de payer...',
  fkckh: 'Référence de paiement :',
  dfwfkqx: 'Si la contrepartie n a pas payé dans {payTime}, la commande sera automatiquement annulée',
  ddqxwfck: 'Commande annulée, impossible de voir les infos de paiement',
  ddqxckh: 'Commande annulée, référence de paiement :',
  ssz: 'En litige, veuillez patienter. Référence de paiement :',
  qxss: 'Annuler le litige',
  xzfkfs: 'Mode de paiement sélectionné',
  ddywc: 'Commande terminée',
  ss: 'Litige',
  wcfqss: '* Vous ne pouvez lancer un litige qu 1 minute après la fin de la commande',
  bnfqss: '* Vous ne pouvez plus lancer de litige après {time} heures',
  zxkf: '* Après un achat OTC, vous devez attendre T+1 jours pour retirer. En cas de doute, contactez le service client.',
  sjyjn: 'Le commerçant a payé une marge de {deposit} {depositName}',
  wen1: '1. Quand vais-je recevoir le paiement ?',
  da1: 'Vous serez notifié une fois que la contrepartie aura effectué le paiement.',
  wen2: '2. L acheteur ne paie pas après avoir passé commande, comment faire ?',
  da2: 'Le vendeur ne peut pas annuler la commande. Si l attente est trop longue, vous pouvez lancer un litige, l équipe service client vous assistera.',
  wen3: '3. Quelles sont les conséquences d un déblocage tardif des actifs numériques ?',
  da3: 'Après réception des fonds, si vous ne confirmez pas la réception rapidement, l acheteur peut lancer un litige, ce qui peut nuire à votre réputation sur la plateforme. En attendant, vos actifs restent gelés dans votre portefeuille.',
  wen4: '4. Précautions lors de la réception de paiement',
  da4: '1) Vérifiez bien plusieurs fois que vous avez bien reçu les fonds. Ne croyez aucune raison pressante de libérer les cryptos. Ne cliquez sur "Confirmer la réception" qu après avoir bien reçu les fonds pour éviter toute perte !<br/>2) Si le compte bancaire de l acheteur ne correspond pas au nom vérifié sur la plateforme, soyez attentif au risque. En cas de doute, lancez un litige.',
  qzgdsjnzf: 'En attente de paiement. Veuillez payer {totalAmounts} {fiatCurrency} à {associatedAdMerchantNickname} dans {payTime}. Référence de paiement :',
  nxdfgm: 'Vous achetez {amount_s} {coinsName} à {associatedAdMerchantNickname} ({realName})',
  dfxngm: '{userNickName} ({realName}) vous achète {amount_s} {coinsName}',
  nxdfcs: 'Vous vendez {amount_s} {coinsName} à {associatedAdMerchantNickname} ({realName})',
  dfxncs: '{userNickName} ({realName}) vous vend {amount_s} {coinsName}',
  payed: 'Payé',
  dddffx: 'En attente du déblocage par la contrepartie…',
  njhdq: 'Vous recevrez {quantity}{coinsName}',
  qxdd: 'Annuler la commande',
  kfqss: '{complaintPayed} minutes après le paiement, si la contrepartie n a toujours pas libéré les cryptos, vous pouvez lancer un litige',
  yfkfkckh: 'La contrepartie a payé. Référence de paiement :',
  qjkqrsk: 'Veuillez confirmer la réception dès que possible',
  ddnsk: 'En attente de votre réception',
  zfje: 'Montant payé',
  skzh: 'Compte de réception :',
  fkzhxm: 'Nom du compte payeur :',
  qdskh: '* Assurez-vous d avoir bien reçu les fonds sur votre outil de paiement avant de confirmer',
  fbl: 'Libérer les cryptos',
  dfyqrfk: '* La contrepartie a confirmé le paiement. Si vous n avez toujours pas reçu les fonds après {complaintPayed} minutes, vous pouvez lancer un litige',
  jkcssk: '* 24 heures après la confirmation de paiement par la contrepartie, vous ne pourrez plus lancer de litige. Veuillez vérifier la réception dès que possible',
  qrfb: 'Confirmer la libération',
  qwbqr: 'Assurez-vous d avoir bien reçu les fonds de cette commande et que le montant est correct avant de libérer',
  wyqrskzq: 'Je confirme avoir reçu les fonds et que le montant est correct',
  tjssyy: 'Veuillez indiquer la raison du litige',
  srssyy: 'Veuillez entrer la raison du litige',
  sctpxt: 'Télécharger une image (optionnel)',
  upload: 'Télécharger',
  zdscsz: '* 3 images maximum, formats jpeg, jpg, png, taille < 3Mb',
  sstj: 'Soumettre',

  qrfk: 'Confirmer le paiement',
  fkje: 'Montant du paiement',
  sdzz: '*La plateforme ne prend pas en charge le débit automatique. Veuillez effectuer le virement vous-même depuis votre compte vers le compte ci-dessus. Après le virement, veuillez cliquer sur "Payé". Si vous ne cliquez pas sur "Payé" après le virement, les pertes éventuelles seront à votre charge.',
  bzts: '*Ne mentionnez pas d informations comme BTC, USDT, BiKing lors du virement, sinon le vendeur peut refuser',
  wfk: 'Non payé',
  w: 'Je',
  srxxfs: 'Saisissez les informations, Entrée pour envoyer',
  dan: 'ordre',
  bnch: 'Impossible d ajouter le même type de mode de paiement',
 sd:'Échange instantané',
 from:'Payer',
 to:'Recevoir',
 rate:'Taux de change',
 successful:'Échange réussi',
 fees:'Frais',
 slippage:'Glissement',
 standards:'Barème des frais',
 transactionamount:'{num} du montant de la transaction',
 confirm:'Confirmer l échange',
 records:'Historique des échanges',
 tocurrency:'Devise dépensée',
 consumption:'Quantité dépensée',
 Getcurrency:'Devise obtenue',
 GetQuantity:'Quantité obtenue',
 ExchangeStatus:'Statut de l échange',
 Exchangetime:'Heure de l échange',
 Youwillconsume:'Vous allez dépenser',
 YouwillGET:'Vous allez obtenir',
 Updatequote:'Mettre à jour la cotation',
 Failed:'Échec de l échange',
 Consumption:'Canal de dépense',
 Completed:'Terminé',
 chaeckrecords:'Voir tout l historique des échanges >',
Converted:'Vous avez échangé avec succès {aaa} contre {bbb}',
recommend:'Recommandé',
wcsj: "Date d'achèvement",
}
const otcMerchant = {
  bzj: 'Marge',
  mmggs: 'Nombre d annonces',
  bx: 'Illimité',
  ggzed: 'Montant total des annonces',
  kzjgged: 'Montant d annonce supplémentaire disponible',
  zjbzjbs: 'Multiplicateur de marge supplémentaire',
  tbzss: 'Affichage synchronisé de 10 éléments',

  tjsjsqb: 'Soumettre la demande de commerçant',
  wcgjkycrz: 'Effectuer la vérification KYC avancée',
  ynlx: 'Après examen du formulaire, un agent OTC vous contactera rapidement',

  zbzl: 'Préparer les documents',
  kssh: 'Vérification rapide',
  
  h1: 'Trading intelligent',
  h2: 'Devenez un expert du trading C2C',
  h3: 'Bientôt commerçant certifié',
  sjqy: 'Avantages commerçant',
  c2cjy: 'En plus des <span>0 frais</span> sur le C2C, nous offrons de nombreux autres avantages aux commerçants',
  fbq: 'Votre zone fiat',
  ptsj: 'Commerçant standard',
  xsqy: 'Devenez commerçant certifié et profitez de plus d avantages',
  wtd: 'Publiez des ordres dès l acceptation',
  xjn: 'Marge requise : {deposit}',
  ljsq: 'Postuler maintenant',
  cwptsj: 'Vous êtes maintenant commerçant standard',
  cwrzsj: 'Vous êtes maintenant commerçant certifié',
  rzsj: 'Commerçant certifié',
  xrd: 'Bénéficiez de la plus haute confiance sur le marché',
  nbyq: 'Uniquement sur invitation interne Biking',
  rzbs: 'Badge commerçant certifié plus prestigieux',
  pmq: 'Obtenez la priorité de classement',
  kffw: 'Bénéficiez d un service client 1:1',
  sjxy: 'Accord C2C {level}',
  xsjc: 'Tutoriel débutant',
  jygz: 'Règles de trading',
  close: 'Fermer',
  submited: 'J ai soumis',
  submitSuccess: 'Soumission réussie',

  sqsj: 'Postuler pour devenir commerçant',
  fwxy: 'Accord de service du site commerçant Biking',
  xyb: 'Biking est une plateforme dédiée au trading d actifs numériques et aux services associés...',
  ptsm: 'Déclaration de la plateforme :',
  p1: '1. Ce site Web sert uniquement de place de marché pour les transactions d actifs numériques. La plateforme ne participe à aucune transaction substantielle, les parties doivent donc évaluer elles-mêmes l authenticité et la légalité des actifs/informations.',
  p2: '2. Aucun contenu (opinions, analyses, prix, etc.) ne constitue un conseil en investissement. Nous ne sommes pas responsables des pertes directes ou indirectes liées à ces informations.',
  p3: '3. Le contenu peut être modifié sans préavis. Nous prenons des mesures raisonnables pour assurer l exactitude, mais ne pouvons garantir la précision ni être tenus responsables des pertes liées aux informations ou aux problèmes de connexion/délai.',
  p4: '4. L utilisation d un système de trading sur Internet comporte des risques (logiciels, matériel, connexion). Nous ne sommes pas responsables des distorsions, retards ou échecs de connexion.',
  p5: '5. L utilisation de ce site pour des activités illégales (blanchiment, trafic d influence, corruption) est interdite. Nous prendrons des mesures (gel de compte, notification aux autorités) et déclinons toute responsabilité.',
  p6: '6. Les manipulations de marché et les comportements contraires à l éthique sont interdits. Nous prendrons des mesures préventives (avertissements, restrictions, fermeture de compte) et déclinons toute responsabilité.',
  p7: 'En acceptant les conditions de service de Biking, vous acceptez l intégralité de cette déclaration. Cet accord constitue un contrat complet entre vous et Biking.',
  zcbzj: 'Article 1 : Marge',
  p8: '1. Après vérification KYC et anti-blanchiment, la plateforme exigera une marge sur le compte du commerçant pour garantir la sécurité et la fluidité des transactions.',
  p9: '2. Le montant de la marge sera affiché dans les actifs fiat du commerçant sur la plateforme et pendant les transactions.',
  p10: '3. La plateforme peut saisir la marge (gel ≥1 mois) dans les cas suivants, avec déduction proportionnelle en cas de perte avérée.',
  p11: '1) Litige où le commerçant est jugé responsable et ne coopère pas ;',
  p12: '2) Transaction avec un compte non vérifié ;',
  p13: '3) Activité illégale via la plateforme ;',
  p14: '4) Violation de l accord ou des règles ;',
  p15: '5) Incitation des utilisateurs à trader sur d autres plateformes ;',
  p16: '6) Incitation aux inscriptions frauduleuses pour obtenir des récompenses de parrainage ;',
  p17: '7) Incitation des utilisateurs des partenaires de la plateforme à migrer.',
  cxzg: 'Article 2 : Révocation du statut de commerçant',
  p18: 'La plateforme peut révoquer votre statut de commerçant dans les cas suivants :',
  p19: '1. Plaintes répétées des utilisateurs ;',
  p20: '2. Informations fausses dans la demande ;',
  p21: '3. Fraude ou malhonnêteté lors des transactions ;',
  p22: '4. Non-coopération avec le service client pour traiter les commandes ;',
  p23: '5. Exploitation malveillante des règles ;',
  p24: '6. Violation des lois, de l accord ou des règles ;',
  p25: '7. Comportement contraire aux bonnes mœurs ou à l équité ;',
  p26: '8. Autres comportements illégaux.',
  zlbh: 'Article 3 : Protection des données du commerçant',
  p27: '1. Les documents d authentification soumis sont conservés par le site, qui s engage à ne pas les divulguer sauf cas prévus par la loi ou le contrat.',
  p28: '2. Transmission aux autorités judiciaires et administratives ;',
  p29: '3. Transmission aux entreprises affiliées ;',
  p30: '4. Transmission à un tiers partenaire pour vous fournir un service ;',
  p31: '5. Transmission à un tiers en cas de litige civil.',
  sjcn: 'Article 4 : Engagement du commerçant',
  p32: '1. Accepter l intégralité de l accord est une condition préalable.',
  p33: '2. La demande ne doit pas être faite à des fins illégales ou interdites.',
  p34: '3. Ne pas nuire, surcharger ou endommager le site ou interférer avec l utilisation du service.',
  p35: '4. Ne pas obtenir de données/informations sans autorisation.',
  p36: '5. Les transactions ne doivent pas violer la loi ni perturber l ordre du marché.',
  p37: '6. Le commerçant s engage à fournir les documents/informations demandés, faute de quoi la plateforme peut révoquer le statut.',
  ptmz: 'Article 5 : Clause de non-responsabilité',
  bcfx: 'La plateforme n est pas responsable dans les cas suivants :',
  p38: '1. Divulgation d informations due à une négligence de l utilisateur (partage de mot de passe, etc.) ;',
  p39: '2. Piratage, virus, problèmes techniques, mesures gouvernementales, force majeure, etc. ;',
  p40: '3. Divulgation d informations bancaires via des liens externes (banque en ligne) ;',
  p41: '4. Informations erronées/incomplètes fournies par l utilisateur ;',
  p42: '5. Fraude subie par l utilisateur pour des raisons indépendantes de la plateforme.',
  ptts: 'Article 6 : Avis de la plateforme',
  p43: '1. Le site peut contenir des liens vers des sites tiers. Nous ne sommes pas responsables de leur contenu.',
  p44: '2. La plateforme fournit uniquement un service de place de marché, n achète ni ne vend elle-même, et ne propose pas de services de dépôt/retrait de monnaie fiduciaire.',
  p45: '3. En utilisant le site, vous acceptez l intégralité de l accord, y compris ses modifications.',
  p46: '4. Cliquer sur "Accepter" ou utiliser les services équivaut à accepter les termes de l accord, sans signature manuscrite.',
  p47: '5. Nous pouvons modifier l accord avec notification sur le site, effective immédiatement après publication.',
  tyxy: 'J accepte les termes de cet accord',
  nextStep: 'Étape suivante'
}
const user = {
  txxz: 'Les modifications du mot de passe de trading bloquent les retraits pendant 24 heures',
  name: 'Pseudonyme',
  rzdj: 'Niveau de vérification d identité',
  phone: 'Téléphone',
  email: 'E-mail',
  zzc: 'Valorisation des actifs',
  hours24: '24 heures',
  market: 'Tendances du marché',
  notice: 'Annonces',
  more: 'Plus >>',
  cb: 'Dépôt crypto',
  tb: 'Retrait crypto',
  hz: 'Transfert',
  wsm: 'Non vérifié',
  cjrz: 'Vérification de base',
  gjrz: 'Vérification avancée',
  qwgjrz: "Effectuer la vérification avancée",
  aqszx: 'Éléments de sécurité configurés',
  xgaqszx: 'Modifier vos éléments de sécurité',
  dlmm: 'Mot de passe de connexion',
  zjdl: 'En définissant un mot de passe de connexion, vous pourrez vous connecter avec votre compte et votre mot de passe.',
  ghmm: 'Changer le mot de passe',
  sz: 'Définir',
  jymm: 'Mot de passe de trading',
  yzjymm: 'Le mot de passe de trading est requis pour les mouvements de fonds.',
  ghjymm: 'Changer le mot de passe de trading',
  sjyz: 'Vérification par téléphone',
  yzdx: 'Utilisé pour recevoir les SMS de vérification (connexion, retrait, modification mot de passe, sécurité)',
  xgsj: 'Modifier le numéro de téléphone',
  zwbd: 'Non lié pour le moment',
  ggyz: 'Google Authenticator',
  syzn: 'Guide d utilisation',
  bd: 'Lier',
  yxyz: 'Vérification par e-mail',
  tbqr: 'Vous pouvez lier un e-mail pour la connexion, la récupération de mot de passe et la confirmation de retrait.',
  bdyx: 'Lier un e-mail',
  xgyx: "Modifier l'e-mail",
  xyx: "Nouvel e-mail",
  dljl: '10 dernières connexions',
  zjdljl: 'Voici vos 10 dernières connexions',
  dlsj: 'Dernière connexion',
  ip: 'Adresse IP',
  aqsz: 'Paramètres de sécurité',
  yhdl: 'Connexion utilisateur',
  xgbdsj: 'Modifier le téléphone lié',
  bdsj: 'Lier un téléphone',
  dxyzm: 'Code SMS',
  second: 's',
  fsyzm: 'Envoyer le code',
  xsjh: 'Nouveau numéro de téléphone',
  ggyzm: 'Code Google Authenticator',
  yxyzm: 'Code e-mail',
  confirm: 'Confirmer',
  edit: 'Modifier',
  name: 'Nom',
  srxm: 'Veuillez entrer votre nom',
  zjlx: 'Type de pièce d identité',
  xzzjlx: 'Sélectionnez le type de pièce',
  zjhm: 'Numéro de pièce',
  srzjhm: 'Veuillez entrer le numéro',
  zcsr: 'Veuillez ressaisir le mot de passe',
  mmbyz: 'Les mots de passe ne correspondent pas !',
  sfz: 'Carte d identité',
  jgz: 'Carte militaire',
  hz: 'Passeport',
  jmtxz: 'Permis de résident de Taïwan',
  gatxz: 'Permis de résident de Hong Kong/Macao',
  hwid: 'ID étranger',
  srdx: 'Veuillez entrer le code SMS',
  sryx: 'Veuillez entrer le code e-mail',
  srgg: 'Veuillez entrer le code Google',
  jdlmm: 'Ancien mot de passe',
  xdlmm: 'Nouveau mot de passe',
  qrxmm: 'Confirmer le mot de passe',
  qrdlmm: 'Confirmer le mot de passe de connexion',
  jjymm: 'Ancien mot de passe de trading',
  xjymm: 'Nouveau mot de passe de trading',
  qrjymm: 'Confirmer le mot de passe de trading',
  qwcyz: 'Veuillez compléter la vérification',
  smrz: 'Veuillez d abord effectuer la vérification d identité',
  sryzm: 'Veuillez entrer le code de vérification',
  srsjh: 'Veuillez entrer le numéro de téléphone',
  xgdlmm: 'Modifier le mot de passe de connexion',
  szdlmm: 'Définir le mot de passe de connexion',
  xgjymm: 'Modifier le mot de passe de trading',
  szjymm: 'Définir le mot de passe de trading',
  czmm: 'Réinitialiser le mot de passe',
  
  bdgg: 'Lier Google Authenticator',
  lbyzq: 'Téléchargez Google Authenticator',
  smewm: 'Scannez le code QR avec Google Authenticator',
  srdm: 'Si le code QR n est pas lisible, entrez le code manuellement',
  copy: 'Copier',
  copySuccess: 'Copie réussie',
  sryx: 'Veuillez entrer l e-mail',
  srzqyx: 'Veuillez entrer une adresse e-mail valide',
  srsjyzm: 'Veuillez entrer le code SMS',
  sryxyzm: 'Veuillez entrer le code e-mail',
  srggyzm: 'Veuillez entrer le code Google',
  passwordTypeError: 'Format de mot de passe invalide. 8-32 caractères, incluant majuscules, minuscules et chiffres.',
  passwordDiff: 'Les mots de passe ne correspondent pas',
  zcsrxmm: 'Veuillez ressaisir le mot de passe',
  language: 'Langue',
  bdhb: 'Monnaie locale',
  wdbph: 'Préférence stablecoin',
  
  相关问题:"Questions associées",
  为什要进行身份认证:"Pourquoi la vérification d'identité ?",
  上传中:"Téléchargement...",
  开始上传:"Commencer le téléchargement",
  录制第一段视频:"Enregistrer la 1ère vidéo",
  录制第二段视频:"Enregistrer la 2ème vidéo",
  录制完成:"Enregistrement terminé",
  请手持身份证正面:"Tenez la carte d'identité (recto) sous votre visage",
  正对摄像头:"Faites face à la caméra, tenez 5 secondes",
  摘下眼镜:"Retirez lunettes et chapeaux",
  请按视频文字提示录制视频:"Suivez les instructions à l'écran",
  开始录制:"Commencer l'enregistrement",
  第一段视频:"1ère vidéo",
  第二段视频:"2ème vidéo",
  录制一段视频:"Enregistrer une vidéo",
  点击开始录制:"Cliquez pour commencer",
  视频录像认证:"Authentification vidéo",
  身份证号:"Numéro de carte d'identité",
  证件验证:"Vérification du document",
  zjyz: "Vérification du document",
  请确保图片格式为:"Format requis : jpg/jpeg/png, taille < 2 Mo",
  请手持证件照:"Tenez le document avec une signature manuscrite incluant Biking + date du jour",
  当日签名照:"Photo du document + signature du jour",
  上传证件签名页:"Télécharger la page signature",
  请保证所有信息清晰:"Assurez-vous que toutes les infos sont lisibles",
  上传证件页信息:"Télécharger les infos du document",
  请选择国家:"Sélectionnez le pays",
  请上传正面证件照:"Télécharger le recto",
  请上传反面证件照:"Télécharger le verso",
  手持证件照:"Photo tenant le document",
  请选择区域:"Sélectionnez la région",
  认证要求: "Exigences de vérification",
  证件信息: "Infos du document",
  人脸识别: "Reconnaissance faciale",
  立即认证: "Vérifier maintenant",
  什么是加密货币P2P交易: "Qu'est-ce que le trading P2P de cryptomonnaies ?",
  最好的P2P加密货币交易所是什么: "Quelle est la meilleure bourse P2P de cryptomonnaies ?",
  P2P交易的成本有多少: "Combien coûte le trading P2P ?",
  什么是BikingP2P上的商家: "Que sont les commerçants sur Biking P2P ?",
  我们正在审核您的申请: "Votre demande est en cours d'examen",
  预计审核时间: "Délai estimé : 72 heures",
  驳回: "Rejetée",
  未提交: "Non soumise",
  手续费等级: "Niveau de frais",
  去认证: "Vérifier",
  已认证: "Vérifié",
  开通更多权限: "Vérifiez votre identité pour plus d'autorisations",
  在别人贪婪时要保持警惕:"Soyez craintif quand les autres sont avides, et avide quand les autres sont craintifs. — Warren Buffett",
  kyc声明: 'Je suis {Name}, mon numéro de pièce est : {No}. Je m inscris volontairement sur Biking, garantis que le compte est utilisé par moi-même, que la source des fonds est légale, que j ai compris et peux supporter tous les risques de trading, que je n utiliserai pas les cryptos retirées à des fins illégales et que je n utiliserai pas cette plateforme pour des activités illégales (blanchiment, pyramides, change illégal, etc.).',
  编辑头像:"Modifier l'avatar",
  请选择一个头像用作您个人资料的照片:"Choisissez une photo pour votre profil",
  中国:"Chine",
  其他:"Autre" ,
  questionTitle1: '1. Pourquoi fournir une vérification d identité ?',
  questionSubTitle1: 'BiKing utilise un service mondial de vérification d identité conforme pour protéger les fonds de tous les utilisateurs. Veuillez fournir des documents conformes.',
  questionTitle2: '2. Quels sont les avantages de la vérification d identité ?',
  questionSubTitle2: 'Tous les utilisateurs doivent effectuer la vérification d identité pour accéder aux fonctions OTC. Les utilisateurs non vérifiés peuvent toujours effectuer des dépôts/retraits on-chain.',
  questionTitle3: '3. Comment mettre à jour la vérification d identité ?',
  questionSubTitle3: 'Si vos informations changent sous certaines conditions, contactez le service client pour demander une mise à jour.',
  questionTitle4: '4. Combien de temps prend la vérification KYC ?',
  questionSubTitle4: 'Les informations sont généralement vérifiées en 5 minutes, mais cela peut parfois prendre plus de temps.',
  questionTitle5: '5. La vérification d identité BiKing est-elle sûre ?',
  questionSubTitle5: 'La vérification d identité BiKing est sûre. Elle nous aide à créer une plateforme sécurisée pour vous et tous les utilisateurs. Vos documents restent confidentiels.',
  questionTitles:'1. Document expiré ;',
  questionTitles1:'2. Changement de nom sur le document ;',
  questionTitles2:'3. Changement de numéro de pièce ;',
  questionTitles3:'4. Changement de nationalité ;',
  questionTitles4:'5. Mise à jour du document pour utilisation des monnaies fiduciaires ;',
  questionTitles5:'6. Changement pour un nom reconnu par le système (ex : passeport au lieu de carte nationale).',
  Z1001: "Erreur système",
  Z1003: "Vérification interrompue",
  Z2002: "Erreur réseau",
  Z2003: "Heure de l'appareil incorrecte",
  Z2006: "Échec de la vérification",
  Z5050: "Vérification faciale réussie",
  Z5051: "Échec du téléchargement de l'image",
  Z5052: "Erreur de données ou anomalie",
  Z5053: "Erreur réseau",
  Z5054: "Caméra sans permission ou inaccessible",
  Z5055: "Utilisateur annulé",
  Z5056: "Trop de tentatives",
  Z5057: "Délai de téléchargement vidéo dépassé",
  Z5058: "Format vidéo non conforme",
  Z5059: "Aucun visage détecté dans la vidéo",
  Z5128: "La vérification ne correspond pas à la même personne",
  法币充值:'Dépôts & retraits fiat',
  无限额:'Illimité',
  数字货币充值:'Dépôts crypto',
  数字货币提现限额:'Limites de retrait crypto',
  C2C交易限额:'Limites de trading C2C',
  "参数不合法": 'Paramètre invalide',
  h5smrz: "Vérification d'identité",
  bhzhan: "Définissez un mot de passe pour sécuriser votre compte",
  jxsmrz: "Effectuez la vérification d'identité pour garantir la sécurité des fonds",
  qwrz: "Vérifier",
  dgzhzd: "1. Maximum 5 soumissions par jour par compte",
  rhzp: "2. Les photos, vidéos ou documents soumis ne seront pas stockés ni utilisés",
  sfzm: "Justificatif d'identité",
  zjqfg: "Pays émetteur",
  dw: "Localisation",
  sfxx: "Informations d'identité",
  dqdw: "Localisation actuelle",
  gjdq: "Pays/région",
}

const h5 = {
  chart: 'Graphique',
  mmp: 'Carnet d ordres',
  sscj: 'Temps réel',
  wt: 'Ordres',
  lswt: 'Ordres historiques',
  zj: 'Fonds',
  sj: 'Marché',
  ky: 'Disponible',
  zczh: 'Actifs équivalents',
  dj: 'Gelé',
  zwsj: 'Aucune donnée',
  zx: 'Favoris',
  buysell: 'Acheter/Vendre'
}

const worldCup = {
  common: {
    cancel: 'Annuler',
    confirm: 'Confirmer',
    iKnow: 'Je comprends',
    points: 'Points',
    day: 'j',
    hour: 'h',
    minute: 'm',
    second: 's',
  },
  index: {
    liveFeed: 'Flux en direct',
    heroTitle: 'Pari sur la Coupe du Monde',
    heroSplit: 'Partagez',
    heroPrizePool: 'la cagnotte',
    heroSub: 'Gagnez une Tesla et des billets pour la Coupe du Monde !',
    heroJoinedPrefix: 'Déjà',
    heroJoinedSuffix: 'participants, la cagnotte ne cesse de croître',
    activityTimeLabel: 'Période :',
    refreshing: 'Actualisation...',
    releaseToRefresh: 'Relâchez pour actualiser',
    pullToRefresh: 'Tirez pour actualiser',
    livePrizePool: 'Cagnotte en temps réel',
    growing: 'En croissance en temps réel',
    userPoolRatioLabel: 'Cagnotte partagée par les utilisateurs individuels :',
    teamPoolRatioLabel: 'Cagnotte partagée par les équipes :',
    poolCountdownLabel: 'Avant le partage de la cagnotte',
    teamTitle: 'Formez une équipe, doublez vos gains',
    teamSubPrefix: 'Rejoignez une équipe pour augmenter vos',
    teamSubSuffix: 'gains',
    teamAgentTitle: 'Équipe d agents',
    teamAgentDesc: 'Les agents de la plateforme peuvent créer une équipe en un clic. <span class="wc-hl">Les points des membres sont additionnés</span>. Les tâches d équipe offrent <span class="wc-hl">des points bonus</span>. Plus l équipe a de points, plus elle a de chances de <span class="wc-hl">partager la cagnotte</span>.',
    createTeamNow: 'Créer une équipe maintenant',
    applyAgentNow: 'Je ne suis pas agent, postuler',
    teamUserTitle: 'Équipe libre',
    teamUserDesc: 'Sans être agent, rejoignez une équipe libre pour accumuler des <span class="wc-hl2">points d équipe</span> et <span class="wc-hl2">partager la cagnotte</span>.',
    joinNow: 'Rejoindre maintenant',
    championTitle: 'Pronostic du champion',
    championSub: 'Un seul pronostic par utilisateur, verrouillé et non modifiable. Devinez juste pour être éligible au partage de la cagnotte personnelle.',
    championHintPrefix: 'Les utilisateurs ayant deviné le champion gagnant partageront',
    championHintSuffix: 'de la cagnotte',
    championWin: 'Félicitations, vous avez deviné le champion !',
    championLose: 'Dommage, vous n avez pas deviné',
    championWinSub: 'et obtenez une part de la cagnotte personnelle',
    confirmPredict: 'Confirmer le pronostic',
    predictCountdown: 'Avant le pronostic',
    notice1: 'L utilisateur p***12 vient de parier et a gagné 500 points',
    notice2: 'L utilisateur k***88 vient d échanger contre une Tesla',
    notice3: 'L utilisateur a***23 vient de parier et a gagné 1200 points',
    notice4: 'L utilisateur x***56 a gagné 100 points en invitant un ami',
    notice5: 'L utilisateur m***07 vient d échanger 1 billet pour la Coupe du Monde',
    tabPredict: 'Parier',
    tabTask: 'Tâches',
    tabRank: 'Classement',
    tabExchange: 'Échanger',
    tabMine: 'Mon compte',
    tabRules: 'Règles',
  },
  toast: {
    refreshSuccess: 'Actualisation réussie',
    inviteJumping: 'Redirection vers la page d invitation...',
    applyAgentPending: 'Fonction de demande agent en développement, à venir !',
    championLocked: 'Pronostic du champion verrouillé !',
    exchangeSubmitted: 'Demande d échange soumise avec succès. Un agent vous contactera pour la remise du prix.',
    createTeamSubmitted: 'Demande de création d équipe soumise',
    joinedFreeTeam: 'Vous avez rejoint une équipe libre',
  },
  section: {
    predictTitle: 'Paris sur les matchs',
    predictSub: 'Prévoyez le résultat : +10 points si correct, +1 point si incorrect',
    predictRules: 'Règles des paris',
    taskTitle: 'Gagnez des points',
    taskSub: 'Multipliez les tâches, multipliez les récompenses',
    exchangeTitle: 'Boutique d échange',
    exchangeSub: 'Prix variés, premier arrivé, premier servi',
    exchangeRules: 'Règles d échange',
    rankTitle: 'Classement en temps réel',
    rankSub: 'Mesurez-vous aux meilleurs',
    rulesTitle: 'Règles de l activité',
    rulesSub: 'Transparentes et équitables',
  },
  dialog: {
    taskTitle: 'Description de la tâche',
    taskReward: 'Récompense à la fin',
    predictConfirmTitle: 'Pari sur le match',
    predictConfirmHint: 'Quelle équipe va gagner ?',
    predictPay: 'Payer',
    predictPayTip: 'Débit du compte Spot, solde suffisant requis',
    predictConfirmBtn: 'Confirmer le pari',
    predictSuccessTitle: 'Pari réussi',
    predictSuccessDesc: 'Pronostic soumis avec succès. Consultez "Mes paris".',
    exchangeTitle: 'Échange de produit',
    exchangeNeedPoints: 'Points requis',
    exchangeBalance: 'Solde :',
    exchangeContactTitle: 'Remplissez au moins un moyen de contact',
    exchangeTipTitle: 'Note',
    exchangeTip1: 'Veuillez fournir au moins un contact. Un agent vous contactera pour la remise du prix.',
    exchangeTip2: 'Si vous n êtes pas contacté longtemps, contactez le service client.',
    exchangeConfirm: 'Confirmer l échange',
    teamJoinTitle: 'Rejoindre une équipe',
    teamCreateDesc: 'Vous êtes agent, confirmez la création de l équipe ?',
    teamJoinFreeDesc: 'Confirmez-vous rejoindre l équipe libre ?',
    teamJoinTipTitle: 'Note',
    teamJoinTipDesc: 'Vous êtes membre d une équipe d agent, vous ne pouvez pas rejoindre l équipe libre. Invitez votre parrain (agent) à former une équipe.',
  },
  rank: {
    teamRank: 'Classement des équipes',
    personRank: 'Classement individuel',
    yourTeamRank: 'Classement de votre équipe',
    yourPersonRank: 'Votre classement individuel',
    captain: 'Capitaine :',
    currentPoints: 'Points actuels',
    members: 'Membres',
  },
  mine: {
    myPoints: 'Mes points',
    totalPoints: 'Points totaux',
    myPredict: 'Mes paris',
    myExchange: 'Mes échanges',
    myTeam: 'Mon équipe',
    selectTeam: 'Choisir l équipe',
    winTeam: 'Équipe gagnante',
    predictResult: 'Résultat du pari',
    hit: 'Gagné',
    miss: 'Perdu',
    exchangeItem: 'Produit échangé',
    contactInfo: 'Contact',
    exchangeStatus: 'Statut de l échange',
    currentRank: 'Classement actuel',
    memberContribution: 'Contribution des membres',
    teamTaskContribution: 'Contribution aux tâches d équipe',
    loading: 'Chargement...',
    statusDone: 'Terminé',
    statusPending: 'En cours',
    statusFail: 'Échec de l échange',
    logCompleteKyc: 'KYC effectué',
    logFirstRecharge: 'Premier dépôt ≥ 1000 USDT',
    logExchangePrize: 'Échange de prix',
    logMatchPredict: 'Pari sur un match',
    logDailySign: 'Pointage quotidien',
    logFinishTask: 'Tâche accomplie',
    taskFirstRecharge: 'Premier dépôt ≥ 1000 USDT',
    teamTask1: 'Volume de trading Futures cumulé 10000U',
    teamTask2: 'Trading Futures cumulé ≥ 1000 USDT',
    teamTask3: 'Volume de trading Futures cumulé 50000U',
    teamTask4: 'Trading Futures cumulé ≥ 3000 USDT',
    pagerTotal: 'Total {total} entrées',
    prevPage: 'Précédent',
    nextPage: 'Suivant',
    goTo: 'Aller à la',
    page: 'page',
  },
  mobile: {
    title: 'Pari Coupe du Monde',
  },
  nav: {
    entry: 'Pari Coupe du Monde',
  },
  mock: {
    korea: 'Corée',
    germany: 'Allemagne',
    china: 'Chine',
    uk: 'Royaume-Uni',
    france: 'France',
    portugal: 'Portugal',
    senegal: 'Sénégal',
    brazil: 'Brésil',
    india: 'Inde',
    turkiye: 'Turquie',
    usa: 'États-Unis',
    jerseyPack: 'Kit maillot officiel',
    vipCard: 'Carte membre VIP crypto',
    jerseyKeyword: 'Maillot',
  },
  predict: {
    round: {
      group: 'Phase de groupes',
      knockout: 'Phase à élimination directe',
      r16: 'Huitièmes de finale',
      quarter: 'Quarts de finale',
      semi: 'Demi-finales',
      third: 'Match pour la 3ème place',
      final: 'Finale',
    },
    status: {
      joined: 'Participé',
      open: 'Ouvert',
      ongoing: 'En cours',
      ended: 'Terminé',
    },
    btn: {
      joined: 'Déjà parié',
      open: '1USDT parier maintenant',
      ongoing: 'Match en cours',
      ended: 'Paris terminés',
    },
  },
  rules: {
    fundSource: 'Source des fonds',
    poolSplit: 'Partage de la cagnotte',
    teamIntro: 'Description des équipes',
    poolRulesTitle: 'Règles de la cagnotte',
    teamRulesTitle: 'Règles des équipes',
    predictRulesTitle: 'Règles des paris',
    exchangeRulesTitle: 'Règles d échange',
  },
  rulesText: {
    poolDesc1: 'Cagnotte initiale de {100k} USDT. Pendant l activité, une partie des revenus est ajoutée à la cagnotte.',
    poolLine1: '5% de chaque dépôt va à la cagnotte ;',
    poolLine2: '50% des frais de trading Futures vont à la cagnotte ;',
    poolLine3: '10 USDT sont ajoutés pour chaque parrainage valide.',
    teamPoolTitle: 'Règles de partage de la cagnotte (équipes)',
    userPoolTitle: 'Règles de partage de la cagnotte (individuels)',
    poolSplit1: 'Après les quarts, l équipe classée 1ère partage 20% de la cagnotte, le reste continue de croître.',
    poolSplit2: 'Après les demies, l équipe classée 1ère partage 30% de la cagnotte, le reste continue de croître.',
    poolSplit3: 'Après les demi-finales, l équipe classée 1ère partage 50% de la cagnotte, le reste continue de croître.',
    poolSplit4: 'Après la finale, l équipe classée 1ère partage 80% de la cagnotte totale.',
    userPoolLine1: 'Les utilisateurs ayant deviné le champion partagent la cagnotte personnelle.',
    userPoolLine2: 'Tous les utilisateurs ayant deviné le champion partagent 20% de la cagnotte selon leurs points.',
    poolFormula: '*Exemple : N utilisateurs ont deviné le champion, leurs points sont N1,N2...Nn. Cagnotte A. Part individuelle = [A*20%/(N1+N2+...+Nn)] * points individuels.',
    teamRule1: '1. Seuls les agents de niveau 1 peuvent créer une équipe.',
    teamRule2: '2. Si vous n êtes pas agent et ne pouvez pas le devenir, rejoignez l équipe libre.',
    teamRule3: '3. L agent et ses membres forment automatiquement une équipe.',
    teamRule4: '4. Points totaux de l équipe = somme des points des membres + points bonus des tâches d équipe.',
    teamRule5: '5. Conditions pour partager la cagnotte : ≥5 paris pendant l activité + volume Futures ≥500U.',
    predictRule1: '1. Les paris sont fermés après le début du match.',
    predictRule2: '2. Un seul pari par match et par utilisateur.',
    predictRule3: '3. Parier coûte 1 USDT.',
    predictRule4: '4. +10 points pour un pronostic gagnant, +1 point pour un pronostic perdant.',
    predictRule5: '5. En cas de match nul (phase de groupes), +1 point (comme un pronostic perdant).',
    exchangeRule1: '1. Quantités limitées, premier arrivé, premier servi.',
    exchangeRule2: '2. L échange de prix déduit les points correspondants de l utilisateur et de son équipe.',
    exchangeRule3: '3. Fournissez vos coordonnées lors de l échange ; un agent vous contactera.',
    exchangeRule4: '4. Des coordonnées erronées peuvent bloquer la remise du prix. Vérifiez bien et suivez l actualité.',
    exchangeRule5: '5. Si vous n êtes pas contacté longtemps, contactez le service client.',
    timeTitle: 'Période de l activité',
    activePeriodLabel: 'Période :',
    activePeriodValue: '18 mai 00:00 ~ 19 juillet 23:59:23',
    activeTip: 'Les points et la cagnotte sont comptabilisés après le début de l activité.',
    predictPeriodLabel: 'Période des paris :',
    predictPeriodValue: 'Pronostic du champion : 16 juillet 04:30:00 ~ 20 juillet 03:00:00',
    businessTitle: 'Règles commerciales',
    businessRule1: '1. Parrainage valide : dépôt ≥100U, volume Futures ≥5000U.',
    businessRule2: '2. Conditions pour partager la cagnotte : ≥5 paris + volume Futures ≥500U.',
    businessRule3: '3. Les points peuvent être échangés à tout moment, déduits de l utilisateur et de son équipe.',
    businessRule4: '4. Quantités limitées pour les prix physiques.',
    businessRule5: '5. Les billets pour la Coupe du Monde sont échangeables jusqu à la veille du début. Si échange impossible (force majeure), remplacement par USDT équivalents.',
    statementTitle: 'Déclaration solennelle',
    statement1: '1. Un seul compte par utilisateur. La plateforme surveille les appareils/IP. Les comptes liés sont interdits.',
    statement2: '2. Les transactions doivent être authentiques. Toute forme d auto-négociation, de contre-négociation ou de wash trading est interdite.',
    statement3: '3. La plateforme identifie les comportements anormaux (ouverture/fermeture rapides, transactions à prix neutres, etc.).',
    statement4: '4. En cas de comportement anormal, la plateforme peut : annuler les points, exclure l utilisateur, geler/récupérer les récompenses.',
    statement5: '5. Les résultats finaux de la cagnotte et des récompenses font foi. La plateforme a le dernier mot sur l interprétation des règles.',
  },
  exchange: {
    needPoints: 'Points requis',
    stock: 'Stock restant',
    buyNow: 'Échanger',
    soldOut: 'Épuisé',
    badgeUnique: 'Prix unique',
    badgeOnly3: 'Seulement 3',
    badgeOnly8: '🔥 Seulement 8',
    itemFinalTicket: 'Billet pour la finale',
    itemSignedFootball: 'Ballon dédicacé',
  },
  task: {
    earnPoints: 'Gagner des points',
    goFinish: 'Accomplir',
  },
  taskGroup: {
    daily: 'Tâches quotidiennes',
    invite: 'Tâches de parrainage',
    recharge: 'Tâches de dépôt',
    teamTrade: 'Tâches de trading d équipe',
    dailyLimitPrefix: 'Limite de récompense quotidienne',
    teamLimitPrefix: 'Limite de récompense quotidienne (équipe)',
    dailyLimitNum: '50 points',
    inviteLimitNum: '100 points',
    teamLimitNum: '300 points',
    limitSuffix: ', réinitialisée à 00:00:00 (GMT+08:00)',
    rechargeLimitSuffix: 'Le premier dépôt pendant l activité est pris en compte',
    inviteCta: 'Inviter pour gagner des points',
    taskPredictOnce: 'Chaque pari',
    taskTrade10000: 'Chaque 10000U de volume Futures cumulé',
    taskInviteValidUser: 'Chaque parrainage valide',
    taskInviteRegister: 'Inviter un ami à s inscrire',
    taskInviteKyc: 'Inviter un ami à faire son KYC',
    taskInviteRecharge: 'Inviter un ami à faire son premier dépôt',
    taskFirstRecharge100: 'Premier dépôt ≥100 USDT',
    taskFirstRecharge500: 'Premier dépôt ≥500 USDT',
    taskFirstRecharge1000: 'Premier dépôt ≥1000 USDT',
    taskTeamTrade10000: 'Chaque 10000 USDT de volume Futures cumulé, +3 points pour l équipe',
  },
};

export {
  games,
  h5,
  trading,
  download,
  login,
  user,
  advertise,
  otcMerchant,
  otc,
  menu,
  time,
  state,
  text,
  seckillRes,
  header,
  hyy,
  index,
  indexPage,
  Verification,
  NAVS,
  FOOTERS,
  SIDEBAR,
  seckill,
  apply,
  recommend,
  market,
  banner,
  card,
  news,
  info,
  navCard,
  choice,
  plat,
  risk,
  license,
  footer,
  merchandiser,
  codeInfo,
  placeOrder,
  tableList,
  codelist,
  contractHyy,
  common,
  dialog,
  panKou,
  invite,
  property,
  contest,
  taskCenter,
  ieo,
  earn,
  tradingContest,
  agent,
  live,
  hongbao,
  worldCup
};


// WEBPACK FOOTER //
// ./src/i18n/lang/public/fr.js